import { observer } from 'mobx-react';
import HeatmapControls from './HeatmapControls';
import ComparableCompaniesActionButtons from './ComparableCompaniesActionButtons';

/**
 * ComparableCompaniesHeaderMobile - Mobile header for comparable companies section
 *
 * Contains:
 * - Heatmap controls (conditional on heatmap view)
 * - Action buttons (save project, switch view, sort) via shared component
 *
 * Note: Comparable data row is rendered in ComparableCompaniesHeader (desktop header)
 * which is always present in DOM - CSS handles visibility.
 *
 * Uses MobX observer to react to state changes for menus and toggles.
 */
const ComparableCompaniesHeaderMobile = observer(
  ({ state, viewsList, sortOptions, project, profilerAccessStore, utilsStore }) => {
    const hasExtendedAccess = profilerAccessStore.canViewProfilerDetailsExtendedData(project);

    // Mobile filters out chart view on narrow screens (< 600px); TD-2499 also
    // hides it for Lite (no extended access) since the chart is EBIT-centric.
    const filterViewsFn = (view) =>
      utilsStore.windowWidth < 600 || !hasExtendedAccess ? view.id !== viewsList[2].id : true;

    return (
      <div className="results-header-wrap-mobile">
        {/* Heatmap controls - mobile */}
        {state.selectedSimilarCompaniesView === viewsList[1].value && state.layout === 'mobile' && (
          <HeatmapControls state={state} />
        )}

        {/* Action buttons - mobile */}
        <div className="results-header-wrap-mobile-actions">
          <ComparableCompaniesActionButtons
            state={state}
            viewsList={viewsList}
            sortOptions={sortOptions}
            hasExtendedAccess={hasExtendedAccess}
            idSuffix="mobile"
            filterViewsFn={filterViewsFn}
          />
        </div>
      </div>
    );
  }
);

export default ComparableCompaniesHeaderMobile;
